var _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyScreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 180,
    viewBox: "0 0 229 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3087_3031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.9084 124.214L115.36 99.7554C117.993 98.5274 119.132 95.397 117.904 92.7636L86.9289 26.3362L65.9535 18.7018L23.0388 38.7133C20.4053 39.9413 19.266 43.0716 20.494 45.7051L55.9166 121.669C57.1446 124.302 60.2749 125.442 62.9084 124.214Z",
    fill: "url(#paint0_linear_3087_3031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9541 18.7017L86.9295 26.3361L72.6246 33.0066L65.9541 18.7017Z",
    fill: "#D0D5DD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_3087_3031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.981 106.339H145.855C148.76 106.339 151.116 103.984 151.116 101.078V27.7837L135.332 12H87.981C85.0753 12 82.7197 14.3555 82.7197 17.2612V101.078C82.7197 103.984 85.0753 106.339 87.981 106.339Z",
    fill: "url(#paint1_linear_3087_3031)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.333 12L151.117 27.7837H135.333V12Z",
    fill: "#DEDEDE"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_3087_3031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.742 99.724L170.193 124.182C172.826 125.41 175.957 124.271 177.185 121.638L208.16 55.2103L200.526 34.2349L157.611 14.2235C154.978 12.9955 151.847 14.1348 150.619 16.7683L115.197 92.7322C113.969 95.3657 115.108 98.496 117.742 99.724Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.526 34.2349L208.161 55.2102L193.856 48.5398L200.526 34.2349Z",
    fill: "#EEEEEE"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 80.8291,
    y: 80,
    width: 72,
    height: 72
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(4px)",
      clipPath: "url(#bgblur_0_3087_3031_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.8291,
    y: 88,
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint2_linear_3087_3031)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3087_3031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.496 120.667L116.829 116M116.829 116L112.163 120.667M116.829 116V126.5M126.618 123.455C127.756 122.835 128.654 121.853 129.172 120.665C129.691 119.477 129.798 118.15 129.479 116.895C129.159 115.639 128.43 114.525 127.407 113.729C126.384 112.933 125.125 112.501 123.829 112.5H122.359C122.006 111.134 121.348 109.866 120.434 108.791C119.52 107.716 118.375 106.863 117.084 106.294C115.793 105.726 114.389 105.457 112.979 105.509C111.57 105.561 110.19 105.932 108.944 106.594C107.698 107.256 106.619 108.192 105.786 109.331C104.954 110.47 104.391 111.783 104.139 113.171C103.888 114.56 103.954 115.987 104.333 117.346C104.713 118.704 105.395 119.96 106.329 121.017",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.288 47.2129H63.5769C61.8405 47.214 60.1754 47.9042 58.9475 49.1321C57.7197 50.36 57.0294 52.025 57.0283 53.7615V171.855C57.0294 173.592 57.7197 175.257 58.9475 176.485C60.1754 177.713 61.8405 178.403 63.5769 178.404H192.288C194.025 178.403 195.69 177.713 196.918 176.485C198.146 175.257 198.837 173.592 198.838 171.855V53.7615C198.837 52.0249 198.146 50.3598 196.918 49.1319C195.69 47.904 194.025 47.2138 192.288 47.2129Z",
    fill: "#C3C2C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.815 137.367H72.0515C68.4351 137.367 65.5029 134.435 65.5029 130.819V26.4763C65.5029 22.8599 68.4351 19.9277 72.0515 19.9277H183.815C187.432 19.9277 190.364 22.8599 190.364 26.4763V130.819C190.364 134.435 187.432 137.367 183.815 137.367Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5763 132.891V28.5497C67.5763 24.9332 70.5084 22.0011 74.1249 22.0011H185.889C187.166 22.0011 188.354 22.3723 189.36 23.0046C188.203 21.1585 186.155 19.9277 183.815 19.9277H72.0515C68.4351 19.9277 65.5029 22.8599 65.5029 26.4763V130.819C65.5029 133.159 66.7337 135.206 68.5798 136.364C67.9475 135.357 67.5763 134.169 67.5763 132.892V132.891Z",
    fill: "url(#paint3_linear_3087_3031)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M170.064 41.9736H85.8037V46.7755H170.064V41.9736ZM170.064 60.3089H85.8037V65.1108H170.064V60.3089ZM170.064 78.6483H85.8037V83.4502H170.064V78.6483ZM170.064 96.9835H85.8037V101.786H170.064V96.9835Z",
    fill: "#D0D0D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8447 81.4844L117.018 102.658H95.8447V81.4844Z",
    fill: "url(#paint4_linear_3087_3031)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M198.838 104.405V55.6874L190.364 47.2129V104.404H198.838V104.405Z",
    fill: "#D5D5D5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M208.763 108.812L199.634 173.44C199.177 176.671 196.412 179.073 193.149 179.073H62.7168C59.454 179.073 56.6889 176.671 56.2324 173.44L43.8946 86.1114C43.3381 82.169 46.3974 78.6465 50.379 78.6465H90.6593C93.9221 78.6465 96.6872 81.0478 97.1436 84.2781L98.7605 95.7145C99.217 98.9455 101.982 101.347 105.245 101.347H202.28C206.261 101.347 209.321 104.869 208.764 108.812H208.763Z",
    fill: "url(#paint5_linear_3087_3031)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M176.416 150.246H79.4518C78.9203 150.245 78.4071 150.051 78.0084 149.7C77.6097 149.349 77.3528 148.864 77.2858 148.337L76.0726 138.731C76.0341 138.424 76.0613 138.112 76.1526 137.816C76.2438 137.52 76.3969 137.247 76.6017 137.015C76.8065 136.783 77.0584 136.597 77.3406 136.469C77.6228 136.342 77.9289 136.276 78.2386 136.275H177.629C177.938 136.276 178.245 136.342 178.527 136.469C178.809 136.597 179.061 136.783 179.266 137.015C179.471 137.247 179.624 137.52 179.715 137.816C179.806 138.112 179.833 138.424 179.795 138.731L178.582 148.337C178.515 148.864 178.258 149.349 177.859 149.7C177.46 150.051 176.947 150.245 176.416 150.246Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3087_3031",
    x: -1.72949,
    y: 12.0312,
    width: 141.857,
    height: 154.406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3087_3031"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3087_3031"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_3087_3031"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3087_3031",
    result: "effect2_dropShadow_3087_3031"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3087_3031",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_3087_3031",
    x: 62.7197,
    y: 12,
    width: 108.397,
    height: 134.339,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3087_3031"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3087_3031"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_3087_3031"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3087_3031",
    result: "effect2_dropShadow_3087_3031"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3087_3031",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_3087_3031",
    x: 92.9731,
    y: 12,
    width: 141.857,
    height: 154.406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3087_3031"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3087_3031"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_3087_3031"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3087_3031",
    result: "effect2_dropShadow_3087_3031"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3087_3031",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_3087_3031_clip_path",
    transform: "translate(-80.8291 -80)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.8291,
    y: 88,
    width: 56,
    height: 56,
    rx: 28
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3087_3031",
    x1: 59.8268,
    y1: 124.419,
    x2: 18.0273,
    y2: 49.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AECAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3087_3031",
    x1: 85.1016,
    y1: 105.223,
    x2: 79.0878,
    y2: 19.2131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3087_3031",
    x1: 116.829,
    y1: 60,
    x2: 60.8291,
    y2: 116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3087_3031",
    x1: 131.773,
    y1: 82.4803,
    x2: 48.9556,
    y2: -0.338194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3087_3031",
    x1: 109.834,
    y1: 106.056,
    x2: 84.2406,
    y2: 80.4633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E9DD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#164F98",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#395D89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3087_3031",
    x1: 126.329,
    y1: 78.6465,
    x2: 126.329,
    y2: 169.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1877F2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3087_3031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(102.829 102)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyScreen);
export default __webpack_public_path__ + "static/media/empty-screen.8546a6e7fa035f8c03c4d07306c78a06.svg";
export { ForwardRef as ReactComponent };